/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { TotalIncomeDto as DigiworkMaitreDPosDtoBillsTotalIncomeDto } from '../models/Digiwork/MaitreD/Pos/DTO/Bills/total-income-dto';
import { getAllOrders } from '../fn/dashboard/get-all-orders';
import { GetAllOrders$Params } from '../fn/dashboard/get-all-orders';
import { getTotalIncome } from '../fn/dashboard/get-total-income';
import { GetTotalIncome$Params } from '../fn/dashboard/get-total-income';

@Injectable({ providedIn: 'root' })
export class DashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTotalIncome()` */
  static readonly GetTotalIncomePath = '/api/dashboard/{venueId}/total-income';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTotalIncome()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalIncome$Response(params: GetTotalIncome$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoBillsTotalIncomeDto>> {
    return getTotalIncome(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTotalIncome$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalIncome(params: GetTotalIncome$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoBillsTotalIncomeDto> {
    return this.getTotalIncome$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoBillsTotalIncomeDto>): DigiworkMaitreDPosDtoBillsTotalIncomeDto => r.body)
    );
  }

  /** Path part for operation `getAllOrders()` */
  static readonly GetAllOrdersPath = '/api/dashboard/{venueId}/all-orders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllOrders()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOrders$Response(params: GetAllOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoBillsTotalIncomeDto>> {
    return getAllOrders(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllOrders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOrders(params: GetAllOrders$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoBillsTotalIncomeDto> {
    return this.getAllOrders$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoBillsTotalIncomeDto>): DigiworkMaitreDPosDtoBillsTotalIncomeDto => r.body)
    );
  }

}
